export default __webpack_public_path__ + "static/Cashflow 101+202-8-e01723c923c162ad93105a2597c9476a.jpg";